/*
 * @Author: tanyaohua
 * @Date: 2022-03-10 14:14:53
 * @FilePath: \xjmediacloud\app\resourceCenter\service\modal\rejectionWithAppendix\rejectionWithAppendix.js
 * @Description: 
 */
'use strict';
angular.module('prirejectionWithAppendixModule', []).controller('prirejectionWithAppendixCtrl', [
    '$scope',
    '$modalInstance',
    'trsHttpService',
    'option',
    'modalDialog',
    function($scope, $modalInstance, trsHttpService, option, modalDialog) {
        initStatus();
 
        /**
          * [initStatus 初始化状态]
          *
          * @return  {[type]}  [return description]
          */
        function initStatus() {
            $scope.appendixUpload = { 
                options: {
                    maxSize: 300,
                    maxCount: 10,
                    isShowLabel: true,
                    labelName: '附件说明',
                    isShowAddIcon: true,
                    addButtonName: '添加',
                    uploadUrl: '/mcnww/api/upload.do',
                    listStyle: 'table',
                    needToken: 'newest'
                },
                fileList: [],
            };
            $scope.data = {
                content: ''
            };
        }
         
        /**
         * [fileUploadSuccess 附件上传成功的回调]
         *
         * @param   {[type]}  resp  [resp description]
         * @param   {[type]}  file  [resp description]
         *
         * @return  {[type]}        [return description]
         */
        $scope.fileUploadSuccess = function(resp, file) {
            if (resp.data.success === true) {
                delete file.file;
                file.FILEINFO = '上传成功';
                file.FileDesc = resp.data.original;
                file.FileName = resp.data.fileName;
                file.FileUrl = resp.data.previewurl;
            } else {
                file.FILEINFO = '上传失败';
            }
        };

        /**
         * [fileUploadFail 文件上传失败处理]
         *
         * @param   {[type]}  resp  [resp description]
         * @param   {[type]}  file  [file description]
         *
         * @return  {[type]}        [return description]
         */
        $scope.fileUploadFail = function(resp, file) {
            if (resp.status === '413') {
                file.FILEINFO = '文件太大，不得大于' + $scope.appendixUpload.options.max + 'MB!';
            } else {
                file.FILEINFO = '未知错误!';
            }
        };

        /**
         * [fileUploadProgress 文件上传中]
         *
         * @param   {[type]}  evt   [evt description]
         * @param   {[type]}  file  [file description]
         *
         * @return  {[type]}        [return description]
         */
        $scope.fileUploadProgress = function(evt, file) {
            file.FILEINFO = '上传中';
        };
        
        $scope.close = function() {
            $modalInstance.dismiss();
        };
 
        $scope.confirm = function() {
            if ($scope.extrasCheckTheFileSuccess()) {
                var params = {
                    serviceid: 'mlf_ugc',
                    methodname: 'rejectArticle',
                    Method: 'rejectArticle',
                    id: option.docInfo.METADATAID,
                    opinion: $scope.data.content,
                    appendixList: JSON.stringify($scope.appendixUpload.fileList.map(function(file) {
                        return {
                            'fileName': file.FileDesc,
                            'url': file.FileUrl
                        };
                    }))
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                    if (data.success === true) {
                        $modalInstance.close();
                    } else {
                        modalDialog.alertType(data.message, '', 'error', 'confirm', '');
                    }
                });
            }
        };
 
    },
]);
 
